export default "__VITE_ASSET__BgrSvz5U__"